export default __webpack_public_path__ + "6b0dda139c8d8507aedbb14ece3286f3.svg";